import React from 'react';

import { PlusMinusButton, PlusMinusButtonType } from '@sharedComponents/Buttons';
import { ReactFCV } from '@types';
import { noop } from '@utils/general';

import { IButtonQuantitySelectorProps } from './model';
import { StyledLoader, QuantityUnit, QuantityUnitHidden, QuantityValue } from './styled';

export const ButtonQuantitySelector: ReactFCV<IButtonQuantitySelectorProps> = ({
  quantityCounterDisabled,
  quantity,
  unit,
  isLoading = false,
  showUnit,
  showQuantityHandlers = true,
  maximumQuantity = 10,
  onMinusButtonAction = noop,
  onPlusButtonAction = noop,
}) => (
  <>
    {showQuantityHandlers && (
      <PlusMinusButton
        symbol={PlusMinusButtonType.MINUS}
        onClick={onMinusButtonAction}
        disabled={isLoading}
        isVisible={!quantityCounterDisabled && quantity > 0}
      />
    )}
    {isLoading ? (
      <StyledLoader height={1} size={15} />
    ) : (
      <QuantityValue enabled={!quantityCounterDisabled} showUnit={showUnit}>
        {quantity}
      </QuantityValue>
    )}
    {showUnit ? <QuantityUnit>{unit}</QuantityUnit> : <QuantityUnitHidden>{unit}</QuantityUnitHidden>}
    {showQuantityHandlers && (
      <PlusMinusButton
        symbol={PlusMinusButtonType.PLUS}
        onClick={onPlusButtonAction}
        disabled={isLoading}
        isVisible={!quantityCounterDisabled && quantity < maximumQuantity}
      />
    )}
  </>
);
